<template>
  <div class="comment-item">
    <div class="comment-wrapper">
      <div class="left-wrapper">
        <div class="avatar-wrapper">
          <UserCardToggle :id="data.user.id">
            <el-avatar size="medium" shape="square" class="avatar" :style="isMine ? {cursor: 'unset'} : {}" :src="data.user.avatar"
                       @click.native="goSpace(data.user.id)"></el-avatar>
          </UserCardToggle>
        </div>
      </div>
      <div class="right-wrapper">
        <div  @mouseenter="operationShowFlag = true" @mouseleave="operationShowFlag = false">
          <i class="fold-spread" v-show="dataList.length > 0" :class="spreadFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
             @click="spreadFlag = !spreadFlag"></i>
          <div class="operation" v-show="operationShowFlag">
            <el-link icon="el-icon-delete" :underline="false" v-if="isMaster || isMine" @click="delComment">删除</el-link>
            <el-link icon="el-icon-s-comment" :underline="false" v-if="!isMine" @click="commentTrigger">回复</el-link>
          </div>
          <div class="content-wrapper">
            <div class="info">
              <span class="name">{{ showName }}</span>
              <span class="mine-text-grey date">{{ data.date }}</span>
              <Author v-if="masterId === data.user.id"></Author>
              <OnTop v-if="data.onTop === 'Y'"></OnTop>
            </div>
            <TextAutoContainer class="text-content"
                               :content="data.content"></TextAutoContainer>
            <div class="picture" v-if="data.picture" @click.stop>
              <el-image :src="data.picture" :preview-src-list="[data.picture]" fit="cover"></el-image>
            </div>
          </div>

        </div>
        <TriggerDisplayContainer class="comment-editor" ref="triggerC" @callback="$refs.commentEditor.focus()">
          <CommentEditor @submit="submit" ref="commentEditor" :enablePicture="false" :enableAt="false"
                         :placeholder="'回复 ' + showName" :submitFlag="commentSubmitFlag"></CommentEditor>
        </TriggerDisplayContainer>
      </div>
    </div>
    <el-collapse-transition>
      <div class="reply-wrapper" v-show="spreadFlag">
        <div class="reply-item-wrapper" v-show="dataList.length > 0">
          <LiveReplyItem class="reply-item" v-for="(item, i) in dataList" :key="item.id" :data="item"
                         :masterId="masterId"
                         @submitCallback="submitCallback" @delete="deleteReply(i)"></LiveReplyItem>
        </div>
        <div class="reply-sum" v-if="data.replyNum > 0">
          <el-link v-if="!firstLoad" style="font-size: 12px" type="info" :underline="false"
                   @click.stop="loadReplies(1)">{{ data.replyNum }}条回复 <i class="el-icon-view"
                                                                          :class="loadFlag ? 'el-icon-loading' : 'el-icon-view'"></i>
          </el-link>
          <el-pagination v-else
                         :hide-on-single-page="true"
                         small
                         background
                         @current-change="loadReplies"
                         layout="prev, pager, next"
                         :disabled="loadFlag"
                         :page-size="pageSize"
                         :total="data.replyNum">
          </el-pagination>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>

    import TextAutoContainer from '../baseComponent/TextAutoContainer'
    import UserCardToggle from '../userCard/UserCardToggle'
    import CommentEditor from '../component/CommentEditor'
    import LiveReplyItem from '../component/LiveReplyItem'
    import TriggerDisplayContainer from "../baseComponent/TriggerDisplayContainer"
    import Author from "../icon/title/Author"
    import OnTop from "../icon/title/OnTop"
    import IsMine from "../baseComponent/IsMine"
    import {clone} from "../../js/utils/objUtils";

    export default {
        name: "LiveCommentItem",
        mixins: [IsMine],
        components: {
            TextAutoContainer,
            UserCardToggle,
            CommentEditor,
            LiveReplyItem,
            TriggerDisplayContainer,
            Author,
            OnTop
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            masterId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                spreadFlag: true,
                operationShowFlag: false,
                commentSubmitFlag: false,
                loadFlag: false,
                pageSize: 5,
                disableLoad: false,
                caches: [],
                dataList: [],
                firstLoad: false
            }
        },
        created() {
            this.setUserId(this.data.user.id);
            if (this.data.replies) {
                this.dataList = this.data.replies;
            }
        },
        methods: {
            submit(content) {
                if (!content.trim()) {
                    return this.$im.showMessage("请输入回复内容", {icon: 5});
                }
                this.commentSubmitFlag = true;
                this.$im.post("/SPACE/v1/live-replies", {commentId: this.data.id, content: content}, true, (id) => {
                    this.$im.showMessage("回复成功", {icon: 1});
                    this.$refs.commentEditor.clean();
                    this.commentTrigger();
                    if (!this.data.replyNum) {
                        this.$im.getInfo((info) => {
                            this.dataList.push({id: id, from: clone(info), to: clone(this.data.user), content: content, date: '1秒前'})
                        });
                    }
                    let lastPage = this.caches[Math.ceil(this.data.replyNum / this.pageSize)];
                    if (lastPage) {
                        this.$im.getInfo((info) => {
                            lastPage.push({id: id, from: clone(info), to: clone(this.data.user), content: content, date: '1秒前'})
                        });
                    }
                }, () => {
                    this.commentSubmitFlag = false;
                })
            },
            //删除评论
            delComment() {
                this.$emit("delete");
            },
            loadReplies(pageIndex) {
                if (this.caches[pageIndex]) {
                    return this.dataList = this.caches[pageIndex];
                }
                this.loadFlag = true;
                this.$im.get("/SPACE/v1/live-replies", {
                    commentId: this.data.id,
                    pageSize: this.pageSize,
                    pageIndex: pageIndex
                }, true, (list) => {
                    this.firstLoad = true;
                    this.caches[pageIndex] = list;
                    this.dataList = list;
                }, () => {
                    this.loadFlag = false;
                })
            },
            submitCallback(id, item) {
                let page = this.dataList;
                for (let i = 0; page.length; i++) {
                    if (page[i].id === id) {
                        return page.splice(i + 1, 0, item);
                    }
                }
            },
            deleteReply(index) {
                this.$im.showConfirm("确认删除回复？", () => {
                    this.$im.delete("/SPACE/v1/live-replies/" + this.dataList[index].id, null, true, () => {
                        this.dataList.splice(index, 1);
                    })
                });
            },
            commentTrigger() {
                this.$refs.triggerC.trigger()
            },
            goSpace(uId) {
                if (!this.isMine) {
                    this.$router.push("/spaces/" + uId);
                }
            }
        },
        computed: {
            showName() {
                return this.data.user.remarks ? this.data.user.remarks : this.data.user.name
            },
            isMaster() {
                return this.masterId === this.mineId;
            }
        },
    }
</script>

<style scoped>
  .comment-item {
  }

  .comment-wrapper {
    display: flex;
    width: 100%;
  }

  .avatar-wrapper {
    margin-right: 8px;
  }

  .avatar {
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  }

  .right-wrapper {
    width: 100%;
  }

  .content-wrapper {
    padding-right: 60px;
  }

  .operation {
    float: right;
  }

  .operation > * {
    margin-right: 5px;
    font-size: 12px;
  }

  .fold-spread {
    float: right;
    cursor: pointer;
    padding: 2px;
  }

  .text-content {
    font-size: 14px;
    padding: 2px 0;
  }

  .picture {
    font-size: 0;
    max-width: 25%;
  }

  .mine-text-grey {
    font-size: 12px;
    color: #666;
  }

  .date {
    vertical-align: bottom;
  }

  .reply-wrapper {
    padding-left: 45px;
  }

  .reply-item-wrapper {
    padding-left: 8px;
    margin: 8px 0;
    border-left: 2px solid #DCDFE6;
  }
  .reply-item-wrapper .reply-item{
    margin-bottom: 5px;
  }
  .reply-wrapper .reply-sum {
    text-align: right;
  }

  .comment-editor {
    padding: 12px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: 8px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/component/LiveCommentItem.vue